<div class="main-content srr-page">
	<div class="container-fluid">
		<div class="card srr-card">
			<div class="card-header card-header-{{ globalSearchService.color }}-6 srr-header">
				<h4 class="card-title">
					<i class="material-icons srr-back" (click)="back()">arrow_back</i>
					My route
					<span class="srr-week" *ngIf="weekStart">· week of {{ weekStart }}</span>
				</h4>
				<button mat-button type="button" class="srr-plan-link" (click)="openPlanner()">
					<i class="material-icons">event</i> Planner
				</button>
			</div>
			<div class="card-body srr-body">

				<p class="srr-status" *ngIf="status">{{ status }}</p>

				<div class="srr-nosm" *ngIf="!salesman && !loading">
					We couldn't tell who you are. Ask your manager to connect your login to your salesperson code, then this page will show your route.
				</div>

				<!-- Day chips (scroll) + pinned Near me -->
				<div class="srr-days-bar" *ngIf="salesman">
					<div class="srr-days">
						<button type="button" class="srr-day" *ngFor="let d of visibleDays"
							[class.is-active]="d.dow === activeDow" (click)="selectDay(d.dow)">
							{{ d.label }} <em class="srr-day-date">{{ dayDate(d.dow) }}</em><span class="srr-day-n" *ngIf="dayCount(d.dow)">{{ dayCount(d.dow) }}</span>
						</button>
					</div>
					<button type="button" class="srr-nearby-toggle" [class.is-active]="showNearby" (click)="toggleNearby()">
						<i class="material-icons">near_me</i> Near me
					</button>
				</div>

				<!-- Progress -->
				<div class="srr-progress" *ngIf="dayStops.length">
					<div class="srr-progress-bar"><div class="srr-progress-fill" [style.width.%]="progressPct"></div></div>
					<span class="srr-progress-text">{{ finishedStops.length }} / {{ dayStops.length }} · {{ doneCount }} visited<ng-container *ngIf="dayMiles > 0"> · ~{{ dayMiles | number:'1.0-0' }} mi</ng-container></span>
					<button mat-icon-button type="button" class="srr-daymap" (click)="openDayInMaps()" [disabled]="!pendingStops.length" title="Open remaining stops in Google Maps">
						<i class="material-icons">map</i>
					</button>
				</div>

				<p class="srr-empty" *ngIf="loading">Loading route…</p>
				<div class="srr-empty srr-noplan" *ngIf="!loading && salesman && !dayStops.length">
					<p>No stops planned for this day.</p>
					<button mat-stroked-button color="primary" type="button" (click)="openPlanner()">Plan the week</button>
				</div>

				<!-- All-done banner -->
				<div class="srr-done-banner" *ngIf="dayComplete">
					<i class="material-icons">celebration</i>
					<span>Day complete — {{ doneCount }} visit{{ doneCount === 1 ? '' : 's' }} logged.</span>
				</div>

				<!-- Current stop -->
				<section class="srr-current" *ngIf="currentStop as cs">
					<div class="srr-current-tag">Next stop</div>
					<div class="srr-current-name">
						{{ stopLabel(cs) }}
						<span class="srr-chip srr-chip-prospect" *ngIf="cs.stop_type === 'prospect'">Prospect</span>
						<span class="srr-chip srr-chip-prio" *ngIf="priorityLabel(cs.priority)">{{ priorityLabel(cs.priority) }}</span>
					</div>
					<div class="srr-current-addr" *ngIf="stopAddress(cs)">{{ stopAddress(cs) }}</div>
					<div class="srr-current-meta">
						<span class="srr-badge" [class.never]="neverContacted(cs)">{{ contactBadge(cs.last_visit_date, cs.last_order_date) }}</span>
					</div>
					<div class="srr-current-actions">
						<button mat-raised-button color="primary" type="button" (click)="navigateTo(cs)">
							<i class="material-icons">navigation</i> Navigate
						</button>
						<button mat-raised-button color="accent" type="button" (click)="openCheckin(cs)">
							<i class="material-icons">how_to_reg</i> Check in
						</button>
						<a mat-stroked-button *ngIf="cs.phoneno" [href]="telHref(cs.phoneno)">
							<i class="material-icons">call</i> Call
						</a>
						<button mat-stroked-button type="button" (click)="openNotes(cs)">
							<i class="material-icons">sticky_note_2</i> Notes
						</button>
						<button mat-stroked-button type="button" *ngIf="cs.stop_type === 'customer'" (click)="createOrder(cs)">
							<i class="material-icons">receipt_long</i> Order
						</button>
						<button mat-stroked-button type="button" *ngIf="cs.stop_type === 'prospect'" (click)="createCustomer(cs)">
							<i class="material-icons">person_add</i> New customer
						</button>
						<button mat-button type="button" class="srr-skip" (click)="setStatus(cs, 'skipped')">Skip</button>
					</div>
				</section>

				<!-- Up next -->
				<section class="srr-list" *ngIf="upNextStops.length">
					<h6 class="srr-list-title">Up next</h6>
					<div class="srr-row" *ngFor="let s of upNextStops; let i = index">
						<span class="srr-seq">{{ i + 2 }}</span>
						<div class="srr-row-main" (click)="openNotes(s)">
							<div class="srr-row-name">{{ stopLabel(s) }}
								<span class="srr-chip srr-chip-prospect" *ngIf="s.stop_type === 'prospect'">P</span>
							</div>
							<div class="srr-row-sub">{{ stopAddress(s) }}</div>
						</div>
						<button mat-icon-button type="button" (click)="navigateTo(s)" title="Navigate"><i class="material-icons">navigation</i></button>
						<button mat-icon-button type="button" (click)="openCheckin(s)" title="Check in"><i class="material-icons">how_to_reg</i></button>
					</div>
				</section>

				<!-- Finished -->
				<section class="srr-list" *ngIf="finishedStops.length">
					<h6 class="srr-list-title srr-list-toggle" (click)="showDone = !showDone">
						Finished ({{ finishedStops.length }})
						<i class="material-icons">{{ showDone ? 'expand_less' : 'expand_more' }}</i>
					</h6>
					<ng-container *ngIf="showDone">
						<div class="srr-row is-finished" *ngFor="let s of finishedStops">
							<i class="material-icons srr-finished-icon" [class.is-skipped]="s.stop_status === 'skipped'">
								{{ s.stop_status === 'done' ? 'check_circle' : 'remove_circle_outline' }}
							</i>
							<div class="srr-row-main" (click)="openNotes(s)">
								<div class="srr-row-name">{{ stopLabel(s) }}</div>
								<div class="srr-row-sub">{{ s.stop_status === 'done' ? 'Visited' : 'Skipped' }}</div>
							</div>
							<button mat-button type="button" (click)="setStatus(s, 'pending')">Undo</button>
						</div>
					</ng-container>
				</section>

				<!-- Nearby -->
				<section class="srr-nearby" id="srrNearby" *ngIf="showNearby">
					<div class="srr-nearby-head">
						<h6 class="srr-list-title mb-0">
							Near {{ nearbyOrigin?.label || 'me' }}
							<em *ngIf="nearbyOrigin">within {{ nearbyRadius }} mi</em>
						</h6>
						<select class="srr-sel" [(ngModel)]="nearbyRadius" (change)="refreshNearby()" aria-label="Radius">
							<option [ngValue]="5">5 mi</option>
							<option [ngValue]="10">10 mi</option>
							<option [ngValue]="25">25 mi</option>
							<option [ngValue]="50">50 mi</option>
						</select>
						<button mat-icon-button type="button" (click)="refreshNearby()" [disabled]="locating || nearbyLoading" title="Refresh">
							<i class="material-icons">my_location</i>
						</button>
					</div>
					<div class="srr-nearby-tabs">
						<button type="button" [class.is-active]="nearbyTab === 'customers'" (click)="nearbyTab = 'customers'">
							My customers ({{ nearbyCustomers.length }})
						</button>
						<button type="button" [class.is-active]="nearbyTab === 'prospects'" (click)="nearbyTab = 'prospects'">
							New leads ({{ nearbyProspects.length }})
						</button>
					</div>
					<p class="srr-empty" *ngIf="locating || nearbyLoading">{{ locating ? 'Getting your location…' : 'Searching nearby…' }}</p>

					<ng-container *ngIf="!locating && !nearbyLoading">
						<div class="srr-row" *ngFor="let r of (nearbyTab === 'customers' ? nearbyCustomers : nearbyProspects)">
							<span class="srr-dist">{{ r.distance_miles | number:'1.1-1' }}<em>mi</em></span>
							<div class="srr-row-main" (click)="openNotesNearby(r)">
								<div class="srr-row-name">
									{{ r.name }}
									<span class="srr-chip srr-chip-mine" *ngIf="r.kind === 'customer' && r.is_mine">Mine</span>
									<span class="srr-chip srr-chip-assigned" *ngIf="r.assigned">Assigned to me</span>
									<span class="srr-chip srr-chip-pot" *ngIf="r.est_potential">~${{ r.est_potential | number }}/yr</span>
								</div>
								<div class="srr-row-sub">
									{{ nearbyAddress(r) }}
									<span *ngIf="r.license_type"> · {{ r.license_type }}</span>
									<span class="srr-badge" [class.never]="neverContacted(r)"> · {{ contactBadge(r.last_visit_date, r.last_order_date) }}</span>
								</div>
							</div>
							<button mat-icon-button type="button" (click)="navigateTo(r)" title="Navigate"><i class="material-icons">navigation</i></button>
							<button mat-icon-button type="button" (click)="checkinNearby(r)" title="Log a visit"><i class="material-icons">how_to_reg</i></button>
							<button mat-icon-button type="button" *ngIf="r.kind === 'customer'" (click)="createOrder(r)" title="Create order"><i class="material-icons">receipt_long</i></button>
							<button mat-icon-button type="button" *ngIf="r.kind === 'prospect'" (click)="createCustomer(r)" title="Create customer"><i class="material-icons">person_add</i></button>
						</div>
						<p class="srr-empty" *ngIf="nearbyTab === 'customers' && !nearbyCustomers.length">No customers nearby on the map right now.</p>
						<p class="srr-empty" *ngIf="nearbyTab === 'prospects' && !nearbyProspects.length">No new leads nearby right now.</p>
					</ng-container>
				</section>
			</div>
		</div>
	</div>

	<!-- Check-in modal -->
	<div class="srr-modal-backdrop" *ngIf="checkinStop" (click)="cancelCheckin()"></div>
	<div class="srr-modal" *ngIf="checkinStop">
		<header>
			<h3>Check in — {{ checkinStop.name }}</h3>
			<span class="srr-geo-note" *ngIf="checkinGeo"><i class="material-icons">place</i> GPS attached</span>
		</header>
		<div class="srr-modal-body">
			<label>Outcome</label>
			<select [(ngModel)]="checkinOutcome" class="srr-sel w-100">
				<option *ngFor="let o of checkinOutcomes" [value]="o.v">{{ o.l }}</option>
			</select>
			<label>Notes</label>
			<textarea [(ngModel)]="checkinNotes" rows="3" class="srr-inp w-100" placeholder="Optional notes"></textarea>
		</div>
		<footer>
			<button mat-button type="button" (click)="cancelCheckin()" [disabled]="checkingIn">Cancel</button>
			<button mat-raised-button color="primary" type="button" (click)="doCheckin()" [disabled]="checkingIn">
				{{ checkingIn ? 'Saving…' : 'Log visit' }}
			</button>
		</footer>
	</div>

	<!-- CRM notes bottom sheet -->
	<div class="srr-modal-backdrop" *ngIf="crmTarget" (click)="closeNotes()"></div>
	<div class="srr-sheet" *ngIf="crmTarget">
		<app-crm-notes-panel [target]="crmTarget" [salesperson]="salesman" (closed)="closeNotes()"></app-crm-notes-panel>
	</div>
</div>
